import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-quick-link-card')
export class MdcQuickLinkCard extends LitElement {
  @property({ type: String }) title = ''
  @property({ type: String }) href = ''

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-quick-link-card {
			display: flex;
			padding: var(--spacing-100, 1rem);
			flex-direction: column;
			justify-content: space-between;
			align-items: flex-start;
			flex-shrink: 0;
			border-radius: var(--radius-sm, 0.25rem);
			background-color: var(--color-background-Interactive-secondary-default, var(--color-functional-gray-25));
			min-height: 7.5rem;
			transition: background-color 0.3s;
			text-decoration: none;
			color: inherit;
			box-sizing: border-box;
		}

		.mdc-quick-link-card:hover {
			background-color: var(--color-background-Interactive-secondary-hover, var(--color-functional-gray-50));
		}

		.mdc-quick-link-card__title {
			color: var(--color-foreground-interactive-primary-default, var(--color-functional-gray-black));
			font-size: var(--typography-font-size-100, 1rem);
			font-weight: 600;
			line-height: 1.3;
			margin: 0;
			padding: 0;
		}

		/* breakpoints.md */
		@media (min-width: 768px) {
			.mdc-quick-link-card {
				padding: var(--spacing-150, 1.5rem);
				min-height: 11.25rem;
				border-radius: var(--radius-md, 0.5rem);
			}

			.mdc-quick-link-card__title {
				font-size: var(--typography-font-size-112-and-half, 1.125rem);
				letter-spacing: -0.00563rem;
			}
		}
	`

  render() {
    return html`
			<a href=${this.href} class="mdc-quick-link-card">
				<p class="mdc-quick-link-card__title">${this.title}</p>
				<div class="mdc-quick-link-card__button">
					<slot name="button"></slot>
				</div>
			</a>
		`
  }
}
